import { css } from 'styled-system/css';

export const memberMobileLoignStyles = {
	formSection: css({
		paddingBottom: '24px',
		borderBottom: '1px solid {colors.jupiter.grey.40}',
		display: 'flex',
		w: '100%',
		maxW: '300px',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		gap: '24px'
	}),
	secondGroup: css({
		display: 'flex',
		width: '100%',
		maxW: '300px',
		justifyContent: 'space-between',
		alignItems: 'center',
		p: '6px 2px',
	}),
	buttonContainer: css({
		display: 'flex',
		width: '100%',
		maxW: '300px',
		alignItems: 'center',
		fontSize: '14px',
		color: 'jupiter.grey.10',
		fontWeight: 700,
		textAlign: 'center',
		lineHeight: 1,
		flexDirection: 'column',
		mt: '12px',
		gap: '12px'
	}),
	svgActiveFill: css({
		base: {
			mb: '6px',
			fill: 'jupiter.main.primary',
			_mdBelow: {
				w: '46px',
				h: '46px',
			},	
		}
	}),
	img: css({
		base: {
			w: '100%',
			objectFit: 'cover',
			objectPosition: 'center'
		}
	}),
	content: css({
		borderRadius: '0 0 12px 12px',
		w: '100%',
		bgColor: 'jupiter.grey.20',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		flex: '1 1 0%',
		gap: '24px',
		p: '18px 18px 12px 18px',
	}),
	formContainer: css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		w: '100%', 
		p: '12px 12px 24px 12px',
		borderRadius: '6px',
		flex: '0 0 auto',
		'& > form:last-of-type': {
			borderBottom: 'none', 
			paddingBottom: '0',
		},
	}),
	reqErrorText: css({
		color: 'jupiter.error.100',
		minH: '39px',
		fontSize: '12px',
		fontWeight: '500',
		w: '100%',
		px: '3px',
		textAlign: 'center',
		wordBreak: 'break-all',
		flex: 1,
		userSelect: 'none'
	}),
	unlockWrapper: css({
		display: 'flex',
		flexDirection: 'column',
		p: '0 0 12px 0',
		alignItems: 'center',
		mb: '12px'
	}),
	copyRightText: css({
		base: {
			width: '100%',
			textAlign: 'center',
			color: 'jupiter.grey.70',
			bgColor: 'transparent',
			fontSize: '10px',
			fontWeight: '400',
			mt: 'auto',
		}
	}),
	buttonText: css({
		alignSelf: 'stretch',
		margin: 'auto 0',
		padding: '0 6px',
		color: 'jupiter.main.primaryLight',
		userSelect: 'none'
	}),
	dropdownButton: css({
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
		bgColor: 'transparent',
		// color: 'jupiter.main.bodyText',
	}),
	userDropdownButton: css({
		w: '100%',
		display: 'flex',
		alignItems: 'center',
		bgColor: 'transparent',
		color: 'currentcolor',
		fontWeight: '500',
		'& .icon': {
			color: 'currentcolor',
		}
	}),
	userIcon: css({
		base: {
			mr: '6px'
		}
	}),
	creatAccountArrow: css({
		base: {
			ml: 'auto',
		}
	}),
	userDropdown: css({
		'--dropdown-item-border': 'transparent',
		'--dropdown-item-text': 'colors.jupiter.grey.70',
		'& .icon--arrow-down': {
			transform: 'none',
		},
		'&[data-open="true"]': {
			'& .icon--arrow-down': {
				transform: 'rotate(180deg)',
			},
		},
		'& .dropdown__btn': {
			borderRadius: '6px',
			bgColor: 'transparent',
			color: 'jupiter.grey.70'
		},
		'& .dropdown__current': {
			mr: '6px',
			color: 'jupiter.grey.70',
			overflow: 'visible',
		},
		'& .dropdown__container': {
			top: '100%',
			left: '50%',
			transform: 'translateX(-50%)',
			bgColor: 'jupiter.grey.10',
			boxShadow: '0 3px 9px rgba(0, 0, 0, .25)',
		},
		'& .dropdown__item': {
			minH: '30px',
			p: '8px 0 8px 12px',
			_supportHover: {
				_hover: {
					bgColor: 'jupiter.grey.20',
					color: 'jupiter.main.primary'
				},
			},
			'&[data-selected="true"]': {
				bgColor: 'transparent',
				color: 'jupiter.main.primary',
			},
		},
		'& .icon': {
			w: '16px',
			h: '16px',
		}
	}),
	languageDropdown: css({
		'--dropdown-item-border': 'transparent',
		'--dropdown-item-text': 'colors.jupiter.grey.80',
		'& .icon--arrow-down': {
			transform: 'none',
		},
		'&[data-open="true"]': {
			'& .icon--arrow-down': {
				transform: 'rotate(180deg)',
			},
		},
		'& .dropdown__btn': {
			borderRadius: '6px',
			bgColor: 'transparent',
			color: 'jupiter.grey.80',
		},
		'& .dropdown__current': {
			mr: '6px',
			color: 'jupiter.grey.80',
			overflow: 'visible',
		},
		'& .dropdown__container': {
			bottom: '100%',
			top: 'unset',
			left: '50%',
			transform: 'translateX(-50%)',
			bgColor: 'jupiter.grey.10',
			boxShadow: '0 3px 9px rgba(0, 0, 0, .25)',
		},
		'& .dropdown__item': {
			minH: '30px',
			_supportHover: {
				_hover: {
					bgColor: 'jupiter.grey.20',
				},
			},
			'&[data-selected="true"]': {
				bgColor: 'transparent',
				color: 'jupiter.main.primary',
			},
		},
		'& .icon': {
			w: '16px',
			h: '16px',
		}
	}),
	loadingIcon: css({
		w: '24px',
		h: '24px',
	}),
	gestureLoadingIcon: css({
		w: '24px',
		h: '24px',
		color: 'jupiter.grey.60'
	})
};
